import { render, staticRenderFns } from "./ffc_review.vue?vue&type=template&id=57c7f42d"
import script from "./ffc_review.vue?vue&type=script&lang=js"
export * from "./ffc_review.vue?vue&type=script&lang=js"
import style0 from "./ffc_review.vue?vue&type=style&index=0&id=57c7f42d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports